import { createStyles, rem } from "@mantine/core"
import { HelpCenterAquaHaze } from "app/static/frontend/design-constants"

export const useStyles = createStyles((theme) => ({
    item: {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        gap: theme.spacing.xl,
        width: "100%",
        padding: theme.spacing.md,

        border: `1px solid ${HelpCenterAquaHaze}`,
        borderRadius: rem(4),
        background: `#FFFFFF`,
        boxShadow: `0px 4px 8px -4px rgba(0, 0, 0, 0.16)`,
        "& .mantine-Accordion-content": {
            padding: 0,
        },
        "& .mantine-Accordion-control": {
            padding: 0,
        },
        "& .mantine-Accordion-chevron": {
            marginLeft: 0,
        },
    },
    titleContent: {
        cursor: "pointer",
        "& .mantine-Accordion-label": {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: 0,
            "& > svg": {
                width: rem(18),
                height: rem(18),
            },
        },
    },
    title: {
        color: theme.colors.gray[9],
        "& .mantine-Input-input": {
            flex: 1,
            fontWeight: 500,
            fontSize: "1.25rem",
            lineHeight: "1.75rem",
            color: theme.colors.gray[9],
        },
    },
    innerContent: {
        paddingInline: rem(6),
    },
    iconItem: {
        marginRight: "0.4rem",
    },
}))
